package com.example.borshi.web.data

import com.example.borshi.web.model.NutritionalTargets
import com.example.borshi.web.model.NutritionistBasePlan
import com.example.borshi.web.model.PlanCategory
import com.example.borshi.web.model.PricingTemplate

object MockPlans {
    fun getPublicPlans(): List<NutritionistBasePlan> {
        return listOf(
            NutritionistBasePlan(
                basePlanId = "plan_muscle_1",
                planName = "Muscle Builder Pro",
                category = PlanCategory.MUSCLE_BUILDING,
                targetAudience = "Gym goers looking to gain lean muscle",
                description = "High protein plan optimized for muscle recovery and growth. Includes premium lean meats and fish.",
                nutritionalTargets = NutritionalTargets(
                    proteinPerWeek = 1400,
                    caloriesPerDay = 2500,
                    omega3PerWeek = 3000
                ),
                imageUrl = "images/muscle_plan.jpg",
                badgeText = "Most Popular",
                badgeColor = "#FFD700",
                pricingTemplate = PricingTemplate(weeklyBase = 2499.0)
            ),
            NutritionistBasePlan(
                basePlanId = "plan_weight_loss_1",
                planName = "Lean & Light",
                category = PlanCategory.WEIGHT_LOSS,
                targetAudience = "Those seeking healthy weight management",
                description = "Low fat, high protein seafood selection perfect for maintaining a calorie deficit without sacrificing taste.",
                nutritionalTargets = NutritionalTargets(
                    proteinPerWeek = 900,
                    caloriesPerDay = 1800,
                    omega3PerWeek = 2000
                ),
                imageUrl = "images/weight_loss.jpg",
                badgeText = "Low Fat",
                badgeColor = "#4CAF50",
                pricingTemplate = PricingTemplate(weeklyBase = 1999.0)
            ),
            NutritionistBasePlan(
                basePlanId = "plan_general_1",
                planName = "Family Health Mix",
                category = PlanCategory.GENERAL_HEALTH,
                targetAudience = "Families wanting balanced nutrition",
                description = "A perfect mix of river fish and sea fish to keep the whole family healthy and happy.",
                nutritionalTargets = NutritionalTargets(
                    proteinPerWeek = 1000,
                    caloriesPerDay = 2200,
                    omega3PerWeek = 2500
                ),
                imageUrl = "images/family_mix.jpg",
                badgeText = "Best Value",
                badgeColor = "#2196F3",
                pricingTemplate = PricingTemplate(weeklyBase = 2199.0)
            ),
             NutritionistBasePlan(
                basePlanId = "plan_heart_1",
                planName = "Heart Healthy Omega",
                category = PlanCategory.HEART_HEALTH,
                targetAudience = "People prioritizing cardiovascular health",
                description = "Rich in Omega-3 fatty acids from premium marine fish like Salmon and Mackerel.",
                nutritionalTargets = NutritionalTargets(
                    proteinPerWeek = 1100,
                    caloriesPerDay = 2000,
                    omega3PerWeek = 5000
                ),
                imageUrl = "images/heart_health.jpg",
                 pricingTemplate = PricingTemplate(weeklyBase = 2799.0)
            )
        )
    }
}
